"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var UsrPermissionsCtl = /** @class */ (function (_super) {
    __extends(UsrPermissionsCtl, _super);
    function UsrPermissionsCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_comment = UIUtils_1.UIUtils.IProp2Str(function (o) { o.comment; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_allowed_admins_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.allowed_admins_count; });
        _this.dk_allowed_documents_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.allowed_documents_count; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_start_document_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_document_url; });
        _this._errDialog = errDialog;
        return _this;
    }
    UsrPermissionsCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    UsrPermissionsCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    UsrPermissionsCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListAdminPermissionsGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    title: resp.list[i].title,
                    comment: resp.list[i].comment,
                    allowed_admins_count: resp.list[i].allowed_admins_count,
                    allowed_documents_count: resp.list[i].allowed_documents_count,
                    is_deprecated: resp.list[i].is_deprecated,
                    start_document_url: resp.list[i].start_document_url
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    UsrPermissionsCtl.prototype.AddPermission = function (Permission, onDone) {
        var _this = this;
        webAApi_1.DoAddAdminPermission.exec({
            data: {
                title: Permission.title,
                comment: Permission.comment,
                is_deprecated: Permission.is_deprecated,
                start_document_url: Permission.start_document_url
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                title: Permission.title,
                comment: Permission.comment,
                allowed_admins_count: 0,
                allowed_documents_count: 0,
                is_deprecated: Permission.is_deprecated,
                start_document_url: Permission.start_document_url
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    UsrPermissionsCtl.prototype.doFillPermission = function (key, onDone) {
        var _this = this;
        webAApi_1.DoFillDocumentsByPermission.exec({
            data: {
                usr_admin_permission_id: key,
            }
        }, function (resp) {
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    UsrPermissionsCtl.prototype.EditPermission = function (Permission, onDone) {
        var _this = this;
        var _tmp = this.getById(Permission.key);
        if (_tmp) {
            webAApi_1.DoEditAdminPermission.exec({
                data: {
                    usr_admin_permission_id: Permission.key,
                    title: Permission.title,
                    comment: Permission.comment,
                    is_deprecated: Permission.is_deprecated,
                    start_document_url: Permission.start_document_url
                }
            }, function (resp) {
                _tmp.title = Permission.title;
                _tmp.comment = Permission.comment;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.is_deprecated = Permission.is_deprecated;
                _tmp.start_document_url = Permission.start_document_url;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    UsrPermissionsCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    UsrPermissionsCtl.prototype.DeletePermission = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteAdminPermission.exec({
                data: {
                    usr_admin_permission_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    UsrPermissionsCtl.prototype.SetPermissionIsDeprecated = function (key, isDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPermissionIsDeprecated.exec({ data: { permission_id: key, is_deprecated: isDeprecated } }, function (resp) {
                _tmp.is_deprecated = isDeprecated;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return UsrPermissionsCtl;
}(BaseController_1.BaseController));
exports.UsrPermissionsCtl = UsrPermissionsCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/usr_permissions_list/ctl/UsrPermissionsCtl.ts
// module id = 865
// module chunks = 0